import React, { useContext } from 'react';
import { IonIcon, IonImg } from '@ionic/react';
import { DebugLink, useDebugLink } from '../../hooks/DebugHooks';
import { AppContext } from '../../state/AppContextProvider';
import { Auth } from '../../services/AuthService';
import { MenuLink } from './MenuLink';
import { QRCodeIcon } from '../identification/QRCodeIcon';
import { callOutline } from 'ionicons/icons';

type Logo = {
  src: string;
  alt: string;
};
const logo: Logo = {
  src: '/assets/logo/logoPortailWhite.svg',
  alt: 'Logo CIUP',
};

export const LogoHeader: React.FC = () => {
  const { incTouchCount } = useDebugLink();

  const { state } = useContext(AppContext);

  const showQRCodeOffline = Auth.showQRCodeOffline(state.user);
  const showEmergencyContactsOffline = Auth.showEmergencyContactOffline(
    state.user
  );

  const menu: JSX.Element[] = [];

  // Emergency numbers
  showEmergencyContactsOffline &&
    menu.push(
      <MenuLink key={0} to="/emergency" colorClass="bg-secondary">
        <IonIcon icon={callOutline} className="mr-1" />
        Contacts d'urgence
      </MenuLink>
    );

  // QR Code
  showQRCodeOffline &&
    menu.push(
      <MenuLink key={1} to="/my-identity/qr-identification">
        <QRCodeIcon className="mr-1" />
        Afficher mon QR code
      </MenuLink>
    );

  // Debug
  state.showDebug &&
    menu.push(
      <MenuLink key={2} colorClass="bg-gray-600 text-white">
        <DebugLink />
      </MenuLink>
    );

  return (
    <div
      id="landing-logo"
      className={`${
        menu.length === 0 && 'empty-menu'
      } flex flex-col justify-center items-center gap-3 bg-primary text-white w-full h-1/5 xl:h-2/5 rounded-bl-5xl relative`}
    >
      <IonImg
        slot="start"
        className="w-48 md:w-80"
        alt={logo.alt}
        src={logo.src}
        onClick={incTouchCount}
      />
      <ul className="absolute ytall:relative tall:bottom-2 -bottom-4 inline-flex gap-x-2">
        {menu}
      </ul>
    </div>
  );
};
